import {Directive, ElementRef, HostBinding, AfterViewInit, ChangeDetectorRef} from '@angular/core';

/*
* Директива для поиска наилучшей позиции на экране для абсолютно позиционированного элемента.
* */

@Directive({
    selector: '[appFindPosition]'
})
export class FindPositionDirective implements AfterViewInit {
    /**
     * Прозрачность для плавной анимации появления
     * @type {number}
     */
    @HostBinding('style.opacity') private opacity = 0;

    /**
     * По-умолчанию элемент будет позиционироваться ниже родителя, выровненым по левому краю
     * @type {string}
     */
    @HostBinding('style.top') private topPosition = '100%';
    @HostBinding('style.bottom') private bottomPosition = 'auto';
    @HostBinding('style.left') private leftPosition = '0';
    @HostBinding('style.right') private rightPosition = 'auto';

    private native: HTMLElement;

    constructor(
        er: ElementRef,
        private cd: ChangeDetectorRef
    ) {
        this.native = er.nativeElement;
    }

    ngAfterViewInit() {
        /**
         * Берем текущие размеры окна и координаты правого и нижнего края элемента.
         */
        const {innerWidth, innerHeight} = window;
        const {bottom, right} = this.native.getBoundingClientRect();

        /**
         * Если элемент ниже видимого края окна, то показываем его не ниже, а выше родителя
         */
        if (bottom >= innerHeight) {
            this.topPosition = 'auto';
            this.bottomPosition = '100%';
        }

        /**
         * Если элемент выходит правее видимой части окна, то выравниваем его по правой границе, чтобы был направлен в левую сторону
         */
        if (right >= innerWidth) {
            this.leftPosition = 'auto';
            this.rightPosition = '0';
        }

        this.opacity = 1;
        this.cd.detectChanges();
    }
}
